import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        columnGap: theme.spacing(3),
    },
    fullWidth: {
        gridColumn: '1 / -1',
    },
}));

/**
 * Two-column CSS grid layout for NgpLabelValue items.
 * Each child occupies 50% width, reducing vertical space compared to a single-column stack.
 *
 * @example
 * <PropertiesGrid>
 *   <NgpLabelValue dataLabel="Name" dataValue="Router-1" />
 *   <NgpLabelValue dataLabel="IP" dataValue="10.0.0.1" />
 *   <NgpLabelValue dataLabel="Vendor" dataValue="Cisco" />
 * </PropertiesGrid>
 *
 * To make an item span the full width (both columns), wrap it in PropertiesGridFullWidth:
 * @example
 * <PropertiesGrid>
 *   <NgpLabelValue dataLabel="Name" dataValue="Router-1" />
 *   <PropertiesGridFullWidth>
 *     <NgpLabelValue dataLabel="Description" dataValue="Long text..." wrap />
 *   </PropertiesGridFullWidth>
 * </PropertiesGrid>
 */
const PropertiesGrid = ({ children }) => {
    const classes = useStyles();
    return <div className={classes.grid}>{children}</div>;
};

PropertiesGrid.propTypes = {
    children: PropTypes.node.isRequired,
};

/**
 * Wrapper component to make a grid item span the full width (both columns).
 * Use this for long text values like descriptions that need more space.
 */
export const PropertiesGridFullWidth = ({ children }) => {
    const classes = useStyles();
    return <div className={classes.fullWidth}>{children}</div>;
};

PropertiesGridFullWidth.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PropertiesGrid;
